module.exports = __webpack_public_path__ + "img/4a64465.png";